import React, { useState } from "react";
import {
  Car,
  CalendarDays,
  Briefcase,
  CalendarCheck,
  Clock,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  saveToGlobalState,
  removeSpecificData,
} from "../../utils/localStorage";
import UseClientTripsNegotiations from "../../hooks/UseTripsNegotiations/UseClientTripsNegotiations";
import UseTravelerTripsNegotiations from "../../hooks/UseTripsNegotiations/UseTravelerTripsNegotiations";
import UseReceiverTripsNegotiations from "../../hooks/UseTripsNegotiations/UseReceiverTripsNegotiations";

const TravelsAvailable = ({
  tripsAvailable,
  loadingTripsAvailable,
  setSerieCancelTripsAvailable,
  setShowMsgRefuseModal,
  setShowRefuseModal,
}) => {
  const navigate = useNavigate();
  const [visibleTripsAvailable, setVisibleTripsAvailable] = useState(2);

  const { tripsNegotiations: tripsNegotiationsClient } =
    UseClientTripsNegotiations();

  const { tripsNegotiations: tripsNegotiationsTraveler } =
    UseTravelerTripsNegotiations();

  const { tripsNegotiations: tripsNegotiationsReceiver } =
    UseReceiverTripsNegotiations();

  const handleShowMoreTripsAvailable = () => {
    setVisibleTripsAvailable((prev) => prev + 2);
  };

  if (loadingTripsAvailable) {
    return <p>Carregando viagens...</p>;
  }

  return (
    <>
      {tripsAvailable.length > 0 && (
        <div className="search-top viagens-disponibilizadas">
          <span className="recommended">⭐ Viagens Disponibilizadas</span>
        </div>
      )}

      {tripsAvailable.slice(0, visibleTripsAvailable).map((tripAvailable) => (
        <div className="container-travel-card" key={tripAvailable.id}>
          <div className="profile-box profile-box-travel-card">
            <img
              src={tripAvailable.imagem_usuario || "https://i.pravatar.cc/100"}
              alt="perfil"
              className="profile-image"
            />

            <h3 style={{ marginTop: 5 }}>{tripAvailable.nome_usuario}</h3>

            <br />
          </div>

          <div className="info-box">
            <div className="route-tags-row">
              <div className="route-container">
                <div className="location-badge">
                  {tripAvailable.cidade_de_onde_vai_sair}
                </div>

                <div className="icon-box">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1cb5e0"
                    strokeWidth="3"
                  >
                    <path d="M7 7l10 10M17 7v10H7" />
                  </svg>
                </div>

                <div className="location-badge">
                  {tripAvailable.cidade_para_onde_vai}
                </div>
              </div>

              <div className="tags">
                <div className="tags-row">
                  <span className="tag-item">
                    <Car size={16} strokeWidth={2.5} className="tag-icon" />
                    {tripAvailable.meio_transporte}
                  </span>

                  <span className="tag-item">
                    <CalendarDays
                      size={16}
                      strokeWidth={2.5}
                      className="tag-icon"
                    />
                    {tripAvailable.duracao_viagem}
                  </span>
                </div>

                <span className="tag-item">
                  <Briefcase size={16} strokeWidth={2.5} className="tag-icon" />
                  {tripAvailable.tipo_encomenda}
                </span>
              </div>
            </div>

            <div className="dates">
              <div className="date-group">
                <small>SAÍDA</small>
                <div className="date-content">
                  <CalendarCheck size={13} className="blue-icon" />
                  <span className="date-text">
                    {tripAvailable.data_partida_para_busca || "-"} às
                  </span>
                  <div className="time-badge">
                    <span>{tripAvailable.horas_partida || "-"}</span>
                  </div>
                </div>
              </div>

              <div className="date-group">
                <small>CHEGADA</small>
                <div className="date-content">
                  <CalendarCheck size={13} className="blue-icon" />
                  <span className="date-text">
                    {tripAvailable.data_chegada_para_busca} às
                  </span>
                  <div className="time-badge">
                    <span>{tripAvailable.horas_chegada || "-"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-travel-btns">
            <div className="status-badge">Aguardando Cliente</div>

            <div className="travel-actions">
              <button
                className="action-btn ghost"
                onClick={() => {
                  let trip_in_negotiations = false;
                  tripsNegotiationsTraveler.map((trips) => {
                    if (trips.serie_trip === tripAvailable.serie_viagem) {
                      trip_in_negotiations = true;
                    }
                  });

                  if (trip_in_negotiations === true) {
                    setShowMsgRefuseModal("travel_available");
                    setShowRefuseModal(true);
                    return;
                  }

                  removeSpecificData("cidade_origem");
                  removeSpecificData("cidade_origem_main");
                  removeSpecificData("cidade_destino");
                  removeSpecificData("cidade_destino_main");
                  removeSpecificData("cidades_trajeto");
                  removeSpecificData("current_step");
                  removeSpecificData("lat_cidade_origem");
                  removeSpecificData("lng_cidade_origem");
                  removeSpecificData("lat_cidade_destino");
                  removeSpecificData("lng_cidade_destino");
                  removeSpecificData("horas_ida_viagem");
                  removeSpecificData("horas_ida_destino");
                  removeSpecificData("origemHora");
                  removeSpecificData("destinoHora");
                  removeSpecificData("origemData");
                  removeSpecificData("destinoData");
                  removeSpecificData("lat_cidade_origem");
                  removeSpecificData("lng_cidade_origem");
                  removeSpecificData("lat_cidade_destino");
                  removeSpecificData("lng_cidade_destino");
                  removeSpecificData("place_id_origem");
                  removeSpecificData("place_id_destino");
                  removeSpecificData("search_origem");
                  removeSpecificData("search_destino");
                  removeSpecificData("dia_mes_ano_ida_viagem");
                  removeSpecificData("dia_mes_ano_ida_viagem_para_busca");
                  removeSpecificData("dia_mes_ano_ida_destino");
                  removeSpecificData("dia_mes_ano_ida_destino_para_busca");
                  saveToGlobalState({
                    id: tripAvailable.id,
                    current_step: "origem",
                    voltando_trajeto: "nao",
                    editar_trajeto: "sim",
                    viagem_step: 0,

                    cidades_trajeto: [],
                    qual_meio_transporte: tripAvailable.meio_transporte,

                    //place_id_origem: airportPayload.place_id,
                    pais_origem: tripAvailable.pais_origem,
                    cidade_origem: tripAvailable.de,
                    cidade_origem_main: tripAvailable.cidade_de_onde_vai_sair,
                    search_origem: tripAvailable.cidade_de_onde_vai_sair,
                    lat_cidade_origem: tripAvailable.lat_cidade_origem,
                    lng_cidade_origem: tripAvailable.lng_cidade_origem,

                    //place_id_destino: airportPayload.place_id,
                    pais_destino: tripAvailable.pais_destino,
                    cidade_destino: tripAvailable.para,
                    cidade_destino_main: tripAvailable.cidade_para_onde_vai,
                    search_destino: tripAvailable.cidade_para_onde_vai,
                    lat_cidade_destino: tripAvailable.lat_cidade_destino,
                    lng_cidade_destino: tripAvailable.lng_cidade_destino,

                    dia_mes_ano_ida_viagem: tripAvailable.data_partida,
                    dia_mes_ano_ida_viagem_para_busca:
                      tripAvailable.data_partida_para_busca,
                    origemData: tripAvailable.data_partida_para_busca
                      .split("/")
                      .reverse()
                      .join("-"),
                    horas_ida_viagem: tripAvailable.horas_partida,
                    origemHora: tripAvailable.horas_partida,

                    dia_mes_ano_ida_destino: tripAvailable.data_chegada,
                    dia_mes_ano_ida_destino_para_busca:
                      tripAvailable.data_chegada_para_busca,
                    destinoData: tripAvailable.data_chegada_para_busca
                      .split("/")
                      .reverse()
                      .join("-"),
                    horas_ida_destino: tripAvailable.horas_chegada,
                    destinoHora: tripAvailable.horas_chegada,
                    horas_ida_destino: tripAvailable.horas_chegada,
                    destinoHora: tripAvailable.horas_chegada,

                    select_espaco_mala: tripAvailable.tipo_encomenda,
                    informacao_a_viagem: tripAvailable.informacao_sobre_trajeto,
                  });

                  if (tripAvailable.meio_transporte === "aviao") {
                    navigate("/aviao");
                  } else if (tripAvailable.meio_transporte === "onibus") {
                    navigate("/onibus");
                  } else if (tripAvailable.meio_transporte === "trem") {
                    navigate("/trem");
                  } else if (tripAvailable.meio_transporte === "carro") {
                    navigate("/carro");
                  } else if (tripAvailable.meio_transporte === "moto") {
                    navigate("/moto");
                  }
                }}
              >
                Editar trajeto
              </button>
              <button
                className="action-btn delete"
                onClick={() => {
                  setSerieCancelTripsAvailable(tripAvailable.serie_viagem);
                  setShowMsgRefuseModal("cancel_travel_available");
                  setShowRefuseModal(true);
                }}
              >
                Cancelar viagem
              </button>
              <button className="action-btn ghost" style={{ display: "none" }}>
                Editar Cidades no Trajeto
              </button>
            </div>
          </div>

          <div className="description-travel">
            {tripAvailable.informacao_sobre_trajeto}
          </div>
        </div>
      ))}

      {visibleTripsAvailable < tripsAvailable.length && (
        <div className="show-more-container">
          <button
            className="show-more-btn"
            onClick={handleShowMoreTripsAvailable}
          >
            Exibir mais viagens
          </button>
        </div>
      )}
    </>
  );
};

export default TravelsAvailable;
